import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './ShiftReview.css';
import axios from 'axios';
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import bwipjs from 'bwip-js'; 
import { API_URL } from '../environment';

import { useAuth } from '../../context/AuthContext'; // ✅ Import useAuth correctly
// import { permissions } from "./../permissions"; // ✅ Import permissions

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
// import betmap from './betmap.json';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import * as XLSX from 'xlsx';
// import LoadingSpinner from './LoadingSpinner';

function ShiftReview() {
  const betmap = {};
  const navigate = useNavigate();
  const { user, login, logout } = useAuth(); // ✅ Now user, login, and logout are accessible
  const [userId, setUserId] = useState('');


  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);
  // const [hasPendingCheckout, setHasPendingCheckout] = useState(false);

  // Now store startDate/endDate at the top level
  const [dateRangeData, setDateRangeData] = useState({
    startDate: '',
    endDate: '',
  });

  const [activeItemId, setActiveItemId] = useState(null);
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10; // Number of items per page

  const [inputPage, setInputPage] = useState(currentPage);
  const [activeDate, setActiveDate] = useState('LAST_30_DAYS');
  const calendarRef = useRef(null);

// 1) Keep these at the component level
// const [startDate, setStartDate] = useState(null);
// const [endDate, setEndDate] = useState(null);
const [selectingEnd, setSelectingEnd] = useState(false);

const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

// 2) In your date-change handler:
const handleDateChange = async (date) => {
  // If the user is navigating months (returns a string) or typing in something, ignore it:
  if (typeof date === "string") return;

  // Helper function to format dates
  const formatDate = (d, startOfDay = true) => {
    return startOfDay
      ? moment(d).startOf("day").format("YYYY-MM-DD")
      : moment(d).endOf("day").format("YYYY-MM-DD");
  };

  // If no start date is chosen, or if both startDate and endDate are already set, start a new selection:
  if (!startDate || (startDate && endDate)) {
    setStartDate(date);
    setEndDate(null);
    setSelectingEnd(true);
  } else {
    let newStartDate = startDate;
    let newEndDate = date;

    // If the user picks an earlier day than startDate, swap them:
    if (date.isBefore(startDate, "day")) {
      newStartDate = date;
      newEndDate = startDate;
    }

    // If startDate and endDate are the same, extend the end date by one day
    if (newStartDate.isSame(newEndDate, "day")) {
      newEndDate = moment(newEndDate).add(1, "day");
    }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setSelectingEnd(false);

    // Format the dates for API call
    const formattedStart = formatDate(newStartDate, true);
    const formattedEnd = formatDate(newEndDate, false);

    // Update the date range state
    setDateRangeData({
      startDate: formattedStart,
      endDate: formattedEnd,
    });

    // Fetch updated reports
    await refreshShiftsHistory(formattedStart, formattedEnd, 1);
  }
};


// Helper to convert a picked day to "YYYY-MM-DD" (if that's your backend format)
function dateToISO(day, startOfDay = true) {
  if (!day) return "";
  const d = startOfDay
    ? moment(day).startOf("day")
    : moment(day).endOf("day");
  // Returns "YYYY-MM-DD"
  return d.format("YYYY-MM-DD");
}
 

 

  useEffect(() => {
    document.body.classList.add('validate-active');
    return () => {
      document.body.classList.remove('validate-active');
    };
  }, []);

  useEffect(() => {
    // Load tickets whenever currentPage changes
    const { startDate, endDate } = dateRangeData;
    const userId = localStorage.getItem("sun_userId");
    setUserId(userId);
    refreshShiftsHistory(startDate, endDate, currentPage);
  }, [currentPage]);

  // ✅ Function to check access
  // const hasAccess = (path) => user && permissions[user.role]?.includes(path);

  // Common fetch function
  const refreshShiftsHistory = useCallback(async (custStartDate, custEndDate, page = 1) => {
    setLoading(true);
    try {
      let reportsParams = { page, limit };

      const formatDate = (date, startOfDay = true) =>
        startOfDay
          ? new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z'
          : new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z';



      // !NOTE: ALL TIME RANGE SET

      // // If dateRangeData already has them, use them
      // if (dateRangeData.startDate) {
      //   reportsParams.startDate = dateRangeData.startDate;
      // }
      // if (dateRangeData.endDate) {
      //   reportsParams.endDate = dateRangeData.endDate;
      // }

      // // If function arguments are provided, they override
      // if (custStartDate) {
      //   reportsParams.startDate = formatDate(custStartDate, true);
      // }
      // if (custEndDate) {
      //   reportsParams.endDate = formatDate(custEndDate, false);
      // }



      // const storedUser = JSON.parse(localStorage.getItem("sun_user"));
      // const isAdmin = storedUser && storedUser.role === 'ADMIN';
      // const betShopRest = localStorage.getItem('sun_bettingShopId');
      // if (!isAdmin && betShopRest && betShopRest !== 'undefined' && betShopRest !== '-') {
      //   reportsParams.bettingShopId = betShopRest;
      // }
      const userId = localStorage.getItem("sun_userId");
      reportsParams.auditedBy = userId;

      reportsParams.shiftBalance = false;
      reportsParams.status = 'PENDING';

      const shopIds = localStorage.getItem('sun_bettingShopsList').split(',')
      if (shopIds.length) {
        reportsParams.bettingShopIdList = JSON.stringify({ $in : shopIds });
      }

      const response = await axios.get(`${API_URL}/shiftpages`, {
        params: reportsParams, // Pass params dynamically
      });

      const resData = (response && response.data) || [];
      let formattedData = resData.tickets || [];
      setTotalPages(resData.totalPages || 1);

      // Format date/time
      formattedData = formattedData.map((o) => {
        const date = new Date(o.createdAt);
        const formattedTime = new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: '2-digit',
          // year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        }).format(date);
        o.createdAtF = formattedTime;

        if (o.startedShiftAt) {
          o.startedShiftAtF = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            // year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          }).format(new Date(o.startedShiftAt)); 
        } else {
          o.startedShiftAtF = 'N/A';
        }

        if (o.endedShiftAt) {
          o.endedShiftAtF = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            // year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          }).format(new Date(o.endedShiftAt)); 
        } else {
          o.endedShiftAtF = 'N/A';
        }

        const expectedEndTotal = o.stats?.startTotal + o.stats?.floatIncreaseTotal + o.stats?.betTotal - o.stats?.redeemedTotal;
        o.variation = o.stats?.endTotal - expectedEndTotal;

        return o;
      });

      setData(formattedData);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  }, []);

  // Toggle pages
  const handlePageInput = (e) => {
    setInputPage(e.target.value);
  };

  const goToPage = (page) => {
    const pageNum = Math.max(1, Math.min(totalPages, page));
    setCurrentPage(pageNum);
    setInputPage(pageNum);
  };

  // Handle custom date selection from Datetime
  // const handleDateChange = async (date) => {
  //   if (typeof date === "string") return; // Prevent close on month switch
  //   setSelectedDate(date);
  //   setCalendarVisible(false);

  //   const selectedDate = new Date(date.toISOString());
  //   let startDate = new Date(selectedDate.setHours(0, 0, 0, 0)).toISOString();
  //   let endDate = new Date(selectedDate.setHours(23, 59, 59, 999)).toISOString();

  //   const convertToDateOnly = (isoString) => {
  //     if (!isoString) return "";
  //     return new Date(isoString).toISOString().split("T")[0];
  //   };
  //   startDate = convertToDateOnly(startDate);
  //   endDate = convertToDateOnly(endDate);

  //   // Store them at the top level
  //   setDateRangeData({ startDate, endDate });

  //   await refreshShiftsHistory(startDate, endDate, 1);
  // };

 

  const handleDateRange = useCallback(
    async (range) => {
      const today = new Date();
      let startDate, endDate;
  
      if (range === "CUSTOM") {
        setCalendarVisible((prev) => !prev);
        setActiveDate('CUSTOM');
        return;
      }
  
      let activeDateSelected = '';
  
      switch (range) {
        case "TODAY":
          startDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "TODAY";
          break;
  
        case "YESTERDAY":
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          startDate = new Date(yesterday.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(yesterday.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "YESTERDAY";
          break;
  
        case "LAST_7_DAYS":
          const last7Days = new Date(today);
          last7Days.setDate(today.getDate() - 6);
          startDate = new Date(last7Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_7_DAYS";
          break;
  
        case "LAST_30_DAYS":
          const last30Days = new Date(today);
          last30Days.setDate(today.getDate() - 29);
          startDate = new Date(last30Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_30_DAYS";
          break;
  
        default:
          startDate = "";
          endDate = "";
          break;
      }
  
      const formatDate = (d, startOfDay = true) => {
        return startOfDay
          ? moment(d).startOf("day").toISOString()
          : moment(d).endOf("day").toISOString();
      };
    
      // Format the dates for API call
      const formattedStart = formatDate(startDate, true);
      const formattedEnd = formatDate(endDate, false);

      // Update the date range state
      setDateRangeData({
        startDate: formattedStart,
        endDate: formattedEnd,
      });

      setActiveDate(activeDateSelected);
  
      const convertToDateOnly = (isoString) =>
        isoString ? new Date(isoString).toISOString().split("T")[0] : "";
  
      startDate = convertToDateOnly(startDate);
      endDate = convertToDateOnly(endDate);
  
      setStartDate(startDate);
      setEndDate(endDate);
  
      await refreshShiftsHistory(startDate, endDate, 1);
  
      console.log("Date Range Selected:", { startDate, endDate });
    },
    [refreshShiftsHistory]
  );

  useEffect(() => {
    handleDateRange("LAST_30_DAYS");
  }, [handleDateRange]);
  // Initial load: set to "TODAY"

  // useEffect(() => {
  //   handleDateRange("TODAY");
  // }, [handleDateRange]);
  

  // function renderDateRange(startDate, endDate) {
  //   // If there is no startDate at all:
  //   if (!startDate) {
  //     return "No date selected";
  //   }
  
  //   // If endDate is missing or both dates are the same day:
  //   if (!endDate || moment(startDate).isSame(endDate, "day")) {
  //     const date = moment(startDate);
  
  //     // Check if it's Today
  //     if (moment().isSame(date, "day")) {
  //       return date.format("MMM DD, YYYY"); // e.g. "Feb 21, 2025"
  //     }
  
  //     // Check if it's Yesterday
  //     if (moment().subtract(1, "days").isSame(date, "day")) {
  //       return date.format("MMM DD, YYYY"); // e.g. "Feb 20, 2025"
  //     }
  
  //     // Otherwise, just return that date
  //     return date.format("MMM DD, YYYY");
  //   }
  
  //   // Now we have two different days
  //   const start = moment(startDate);
  //   const end = moment(endDate);
  //   const rangeDays = end.diff(start, "days");  
  
  //   // If range is exactly 1 day, just show the end
  //   if (rangeDays === 1) {
  //     return end.format("MMM DD, YYYY");
  //   }
  
  //   // If the end date is "today" and range > 1
  //   if (moment().isSame(end, "day") && rangeDays > 1) {
  //     return `${start.format("MMM DD, YYYY")} - ${end.format("MMM DD, YYYY")}`;
  //   }
  
  //   // If the end date is "today" and range <= 2
  //   if (moment().isSame(end, "day") && rangeDays <= 2) {
  //     return "Today";
  //   }
  
  //   // If the end date is "yesterday" and range <= 2
  //   if (moment().subtract(1, "days").isSame(end, "day") && rangeDays <= 2) {
  //     return "Yesterday";
  //   }
  
  //   // Otherwise, default to "start - end"
  //   return `${start.format("MMM DD, YYYY")} - ${end.format("MMM DD, YYYY")}`;
  // }



  const formatStringWithHyphens = (input) => {
    // Ensure the input is a string of 12 characters
    if (typeof input !== 'string' || input.length !== 12) {
      return '-';
    }
    return input.match(/.{1,4}/g).join('-');
  };

  // const openPopupWithDetails = (id) => {
  //   const selectedItem = data.find((item) => item._id === id);
  //   setActiveItemId(id);
  //   setPopupData(selectedItem);
  //   setPopupVisible(true);
  // };

  // const closePopup = () => {
  //   setPopupVisible(false);
  //   setPopupData(null);
  //   setActiveItemId(null);
  // };

  const backMainMenu = () => {
    navigate('/dashboard');
  };

  // let betAmountFormatted = popupData?.betAmount
  //   ? parseFloat(popupData.betAmount).toFixed(2)
  //   : null;
  // let payoutAmountFormatted = popupData?.payoutAmount
  //   ? parseFloat(popupData.payoutAmount).toFixed(2)
  //   : null;

  // const drawNumber = popupData?.spinNumber; // popupData?.spinId?.prng || '';


  // const handleExport = async() => {


  //   let reportsParams = { page: 1, limit: 1000 };

  //   const formatDate = (date, startOfDay = true) =>
  //     startOfDay
  //       ? new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z'
  //       : new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z';


  //   // If dateRangeData already has them, use them
  //   if (dateRangeData.startDate) {
  //     reportsParams.startDate = formatDate(dateRangeData.startDate, true);
  //   }
  //   if (dateRangeData.endDate) {
  //     reportsParams.endDate = formatDate(dateRangeData.endDate, false);
  //   }

  //   const response = await axios.get(`${API_URL}/shiftpages`, {
  //     params: reportsParams,
  //   });

  //   const resData = (response && response.data) || [];
  //   let formattedData = resData.tickets || [];

  //   // Format date/time
  //   formattedData = formattedData.map((o) => {
  //     const date = new Date(o.createdAt);
  //     const formattedTime = new Intl.DateTimeFormat('en-US', {
  //       month: 'short',
  //       day: '2-digit',
  //       // year: 'numeric',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit',
  //       hour12: true,
  //     }).format(date);
  //     o.createdAtF = formattedTime;

  //     if (o.startedShiftAt) {
  //       o.startedShiftAtF = new Intl.DateTimeFormat('en-US', {
  //         month: 'short',
  //         day: '2-digit',
  //         // year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         hour12: true,
  //       }).format(new Date(o.startedShiftAt)); 
  //     } else {
  //       o.startedShiftAtF = 'N/A';
  //     }

  //     if (o.endedShiftAt) {
  //       o.endedShiftAtF = new Intl.DateTimeFormat('en-US', {
  //         month: 'short',
  //         day: '2-digit',
  //         // year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         hour12: true,
  //       }).format(new Date(o.endedShiftAt)); 
  //     } else {
  //       o.endedShiftAtF = 'N/A';
  //     }

  //     const expectedEndTotal = o.stats?.startTotal + o.stats?.floatIncreaseTotal + o.stats?.betTotal - o.stats?.redeemedTotal;
  //     o.variation = o.stats?.endTotal - expectedEndTotal;

  //     return o;
  //   });

  //   const dataToExport = formattedData.map(item => ({
  //     'SHIFT ID': item._id || '--',
  //     'AGENT': item.agentId?.name || '--',
  //     'STATUS': (item.shiftActive ? 'Open' : 'Close'),
  //     'OPEN TOTAL': item.stats?.startTotal,
  //     'FLOAT INCREASE TOTAL': item.stats?.floatIncreaseTotal,
  //     'TICKETS SOLD QTY': `${item.stats?.numTicketsSold}`,
  //     'TICKETS SOLD': `${item.stats?.betTotal}`,
  //     'TICKETS REDEEMED QTY': `${item.stats?.numTicketsRedeemed}`,
  //     'TICKETS REDEEMED': `-${item.stats?.redeemedTotal}`,
  //     'CLOSE TOTAL': item.stats?.endTotal,
  //     'VARIATION': item.variation,
  //     'SHIFT START': item.startedShiftAtF,
  //     'SHIFT END': item.endedShiftAtF,
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

  //   const { startDate, endDate } = dateRangeData;
  //   const formattedStart = moment(startDate).format("DDMMMYYYY");
  //   const formattedEnd = moment(endDate).format("DDMMMYYYY");

  //   const fileName =
  //     formattedStart === formattedEnd
  //       ? formattedStart
  //       : `${formattedStart}_${formattedEnd}`;

  //   XLSX.writeFile(workbook, `ShiftHistory_${fileName}.xlsx`);
  // };

  return (
    <>
      {/* <button onClick={handleExport} className="btn-export">
        Export to Excel
      </button> */}
      <div className="validate validate-history">
        <div className="validate-top-wrap">
          <div className="validate_top-left">
            <div className="spin-border dashbord-border">
              <div className="spin-light spin-light-top">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
              <div className="spin-number">
                <div className="spin-number__text">
                  <span className="spin-number__text-big">SHIFT REVIEW</span>
                </div>
              </div>
              <div className="spin-light spin-light-bottom">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="validate_top-middel">
          {/* {!startDate ? (
  // If no startDate at all:
  "No date selected"
) : !endDate || moment(startDate).isSame(endDate, "day") ? (
  // If endDate is null OR both dates are the same day:
  (() => {
    const date = moment(startDate);

    // If it's exactly "today":
    if (moment().isSame(date, "day")) {
      return date.format("MMM DD, YYYY"); // e.g. "Feb 21, 2025"
    }
    // If it's exactly "yesterday":
    if (moment().subtract(1, "days").isSame(date, "day")) {
      return date.format("MMM DD, YYYY");
    }
    // Otherwise, just return the single date
    return date.format("MMM DD, YYYY");
  })()
) : (
  // If we have a valid range (two different days):
  (() => {
    const start = moment(startDate);
    const end = moment(endDate);
    const rangeDays = end.diff(start, "days");

    // If the range is exactly 1 day, just show the end date
    if (rangeDays === 1) {
      return start.format("MMM DD, YYYY");
    }

    // If the end date is "today" and range > 1
    if (moment().isSame(end, "day") && rangeDays > 1) {
      return (
        <>
          {start.format("MMM DD, YYYY")}
          {" - "}
          {end.format("MMM DD, YYYY")}
        </>
      );
    }

    // If the end date is "today" and range <= 2
    if (moment().isSame(end, "day") && rangeDays <= 2) {
      return "Today";
    }

    // If the end date is "yesterday" and range <= 2
    if (moment().subtract(1, "days").isSame(end, "day") && rangeDays <= 2) {
      return "Yesterday";
    }

    // Default: "start - end" format
    if (activeDate === 'LAST_7_DAYS' || activeDate === 'LAST_30_DAYS') {
      return (
        <>
          {start.format("MMM DD, YYYY")}
          {" - "}
          {end.subtract(1, "days").format("MMM DD, YYYY")}
        </>
      );
    }
    return (
      <>
        {start.format("MMM DD, YYYY")}
        {" - "}
        {end.format("MMM DD, YYYY")}
      </>
    );
  })()
)} */}

          </div>

          <div className="validate_top-right">
            <button className="return-menu btn-yellow" onClick={backMainMenu}>
              RETURN TO MAIN MENU
            </button>
          </div>
        </div>

        <div className="validate-bottom-wrap shift-top-adj">
          {/* <div className="report_filter-date report_filter-date-valid">
            <div
              className={`report_filter-date-item ${activeDate==='TODAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("TODAY")}
            >
              TODAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='YESTERDAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("YESTERDAY")}
            >
              YESTERDAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_7_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_7_DAYS")}
            >
              LAST 7 DAYS
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_30_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_30_DAYS")}
            >
              LAST 30 DAYS
            </div>
            <div
              className={`report_filter-date-item-custom report_filter-date-item ${activeDate==='CUSTOM' ? "date-active" : ""}`}
              onClick={() => handleDateRange("CUSTOM")}
            >
              <span className="report_filter-date-custom-span">CUSTOM</span>
            </div>

            {isCalendarVisible && (
              <div className="calendar-container">
                <Datetime
                  onChange={handleDateChange}
                  open={true}
                  input={false}
                  timeFormat={false}
                  closeOnSelect={false}
                  ref={calendarRef}
                  isValidDate={(current) => {
                    // Allow all dates when selecting start
                    if (!startDate || !selectingEnd) return true;
                  
                    // When selecting end, it must be same or after start
                    return moment(current).isSameOrAfter(startDate, "day");
                  }}
                  renderDay={(props, currentDate, selectedDate) => {
            
                    let className = props.className;
                    if (startDate && endDate) {
                      if (currentDate.isBetween(startDate, endDate, "day", "[]")) {
                        className += " rdt-day-in-range";
                      }
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                      if (currentDate.isSame(endDate, "day")) {
                        className += " rdt-day-end";
                      }
                    } else if (startDate && !endDate) {
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                    }
                    return (
                      <td {...props} className={className}>
                        {currentDate.date()}
                      </td>
                    );
                  }}

                
                  renderView={(mode, renderDefault, viewProps) => {
   
                    const defaultCalendar = renderDefault();
                    return (
                      <div>
                        {defaultCalendar}
             
                        <div style={{ textAlign: "center", marginTop: 8 }}>
                          <button
                            className="btn-ok"
                            onClick={() => {
          
                              setCalendarVisible(false);
                         
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            )}
            
          </div> */}

          <div className="validate-bot-wrap">
            <div className={`validate-left ${isPopupVisible ? "active-class" : ""}`}>
            <div className="table-maket">
                    <table>
                      <thead>
                        <tr>
                          <th>SHIFT ID</th>
                          <th>AGENT</th>
                          <th>SHOP</th>
                          <th>STATUS</th>
                          <th>OPEN TOTAL</th>
                          <th>FLOAT INCREASE TOTAL</th>
                          <th>TICKETS SOLD</th>
                          <th>TICKETS REDEEMED</th>
                          <th>CLOSE TOTAL</th>
                          <th>VARIATION</th>
                          <th>SHIFT START</th>
                          <th>SHIFT END</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item) => (
                          <tr key={item._id}>
                            <td className="ticket-id-format table-maket-col_yellow">
                              {item._id}
                            </td>
                            <td>{item.agentId?.name}</td>
                            <td>{item.bettingShopId?.name}</td>
                            <td>{item.status}</td>
                            <td>${item.stats?.startTotal}</td>
                            <td>${item.stats?.floatIncreaseTotal}</td>
                            <td>{item.stats?.numTicketsSold} (${item.stats?.betTotal})</td>
                            <td>{item.stats?.numTicketsRedeemed} ($-{item.stats?.redeemedTotal})</td>
                            <td>${item.stats?.endTotal}</td>
                            <td>${item.variation}</td>
                            <td>{item.startedShiftAtF}</td>
                            <td>{item.endedShiftAtF}</td>
                            <td>
                              <button disabled={item.spinId === null}
                                className={`table-maket__btn ${
                                  (activeItemId === item._id)
                                    ? 'table-maket__btn-active'
                                    : ''
                                }`}
                                onClick={() => {
                                  navigate(`/shift-checkout/${item._id}`);
                                }}
                              >
                                {item.auditedBy === userId ? 'View' : 'Checkout'}                                
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination">
                    {/* Previous Button */}
                    <button
                      className="prev"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      &laquo;
                    </button>

                    {/* Always show first page */}
                    <button
                      className={`page ${currentPage === 1 ? "active" : ""}`}
                      onClick={() => goToPage(1)}
                    >
                      1
                    </button>

                    {/* Dots before middle pages */}
                    {currentPage > 4 && totalPages > 6 && <span className="dots">...</span>}

                    {/* Middle pages */}
                    {Array.from({ length: Math.min(5, totalPages - 2) }, (_, index) => {
                      const start = Math.max(2, currentPage - 2);
                      const pageNumber = start + index;
                      if (pageNumber >= totalPages) return null;
                      return (
                        <button
                          key={pageNumber}
                          className={`page ${currentPage === pageNumber ? "active" : ""}`}
                          onClick={() => goToPage(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}

                    {/* Dots before last page */}
                    {currentPage < totalPages - 3 && totalPages > 6 && <span className="dots">...</span>}

                    {/* Always show last page if not already shown */}
                    {totalPages > 1 && (
                      <button
                        className={`page ${currentPage === totalPages ? "active" : ""}`}
                        onClick={() => goToPage(totalPages)}
                      >
                        {totalPages}
                      </button>
                    )}

                    {/* Page Input (jump to) */}
                    <input
                      type="number"
                      className="page-input"
                      value={inputPage}
                      onChange={handlePageInput}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          const page = Math.max(1, Math.min(Number(inputPage), totalPages));
                          goToPage(page);
                        }
                      }}
                      min="1"
                      max={totalPages}
                    />

                    {/* Next Button */}
                    <button
                      className="next"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      &raquo;
                    </button>
                  </div>
              {/* {loading ? (
                <LoadingSpinner />
              ) : (
                <>

                </>
              )} */}
            </div>


          </div>
        </div>
      </div>

      {/* <div id="pdfViewer"></div> */}

      {/* Hidden table for reference if you need it */}
      {/* <div className="ticket-table" style={{ display: "none" }}>
        <h3 className="ticket-table__title">Tickets history</h3>
        <table>
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Bet Amount</th>
              <th>Payout</th>
              <th>Draw</th>
              <th>Redeem</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item._id}>
                <td className="ticket-id-format">{formatStringWithHyphens(item.nanoId)}</td>
                <td>{item.betAmount}</td>
                <td>{item.payoutAmount}</td>
                <td>{item.spinId?.prng}</td>
                <td>{item.redeem}</td>
                <td>{item.createdAtF}</td>
                <td>
                  <button disabled={item.spinId === null}
                    className="wrap-validate_item"
                    onClick={() => openPopupWithDetails(item._id)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </>
  );
}

export default ShiftReview;
